"use client";
import React, { useState } from "react";
import OurButton from "../ourButton";

const services = [
  {
    title: "Development",
    description:
      "Create innovative websites and digital solutions to drive growth and deliver seamless user experiences",
    buttonText: "Explore Development",
    link: "/services/developing",
    bgImage:
      "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FexpandServices%2F1.webp?alt=media&token=b2c51453-1052-493a-9c7e-6ab21eec2dcf",
  },
  {
    title: "Design",
    description:
      "Transform ideas into designs that blend creativity, functionality, and brand impact",
    buttonText: "Design Yourself",
    link: "/services/design",
    bgImage:
      "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FexpandServices%2Fpawel-czerwinski-wqyn1MWyOi8-unsplash.webp?alt=media&token=443c1b5e-e0ed-4dc4-a514-c5bb6dea2425",
  },
  {
    title: "Marketing",
    description:
      "Boost your online presence with data-driven strategies, SEO, and social campaigns",
    buttonText: "Sell More",
    link: "/services/marketing",
    bgImage:
      "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FexpandServices%2F2.webp?alt=media&token=0357561c-f77c-46cf-a094-81a325dbef34",
  },
  {
    title: "Website Maintenance",
    description:
      "Keep your platforms running smoothly with our reliable tech support and maintenance",
    buttonText: "Take Your Help",
    link: "/subscriptions",
    bgImage:
      "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FFirst%20Block%20Images%2Fpawel-czerwinski-2dyR13FNg2I-unsplash.webp?alt=media&token=4842f972-d9f6-47bd-8e2a-a1619d1a4344",
  },
];

const Services = () => {
  const [selected, setSelected] = useState<number>(0); // Default to the first block being expanded

  return (
    <div className="text-center flex justify-center gap-6">
      <div className="max-w-screen-2xl flex justify-center gap-6 flex-col">
        <h3>SERVICES</h3>
        <p className="w-full text-left md:text-center mx-auto">
          We specialize in crafting powerful brands and digital experiences that
          drive growth and innovation. Our services include development, design,
          marketing, and website maintenance, tailored to help your business
          thrive in a competitive landscape. From strategy to execution, we
          empower brands to reach new heights and connect with their audience
          effectively.
        </p>
        <div className=" gap-4 grid grid-cols-1 md:grid md:grid-cols-2 xl:flex sl:justify-between">
          {services.map((service, index) => (
            <a
              key={index}
              href={service.link}
              className={`relative h-[300px] rounded-[35px] overflow-hidden bg-cover bg-center transition-all duration-700 ease-in-out xl:h-[600px] ${
                selected === index ? "xl:flex-[1.2]" : "xl:flex-[0.8]"
              }`}
              style={{ backgroundImage: `url(${service.bgImage})` }}
              onMouseEnter={() => setSelected(index)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="36"
                viewBox="0 0 35 36"
                fill="none"
                className={`absolute top-[10px] right-[10px] transition-all duration-700 ${
                  selected === index ? "-rotate-45" : "rotate-0"
                }`}
              >
                <rect
                  y="0.517578"
                  width="35"
                  height="35"
                  rx="17.5"
                  fill="white"
                />
                <path
                  d="M26.8563 18.0176L19.8391 11.0004M26.8563 18.0176L19.8391 25.0348M26.8563 18.0176L14.5762 18.0176M8.14373 18.0176L11.0676 18.0176"
                  stroke="#2C2D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className="h-full md:h-3/6 absolute bottom-0 left-0 right-0 bg-gradient-to-b from-transparent to-black/80 text-white p-4 flex justify-end align-end flex-col text-left gap-2">
                <h4>{service.title}</h4>
                <p className="my-2 max-w-[300px]">{service.description}</p>
                <div
                  className={`w-full py-2 px-4 rounded-full border transition flex justify-between align-center ${
                    selected === index
                      ? "bg-white text-black"
                      : "bg-transparent text-white border-white"
                  }`}
                >
                  {service.buttonText}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      d="M4 12.7598L20 12.7598M20 12.7598L14 18.7598M20 12.7598L14 6.75977"
                      stroke={`
                                            ${
                                              selected === index
                                                ? "#2C2D2C"
                                                : "#fff"
                                            }`}
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </a>
          ))}
        </div>
        <div className="w-full flex justify-center">
          <OurButton href={"/services"} textForButton={"All Services"} />
        </div>
      </div>
    </div>
  );
};

export default Services;
